module.exports = __webpack_public_path__ + "static/img/108.88905f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/108.png
// module id = m6We
// module chunks = 0